import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getRafflePath } from "./raffleRoute";
import type { RaffleTab } from "./raffleTabs";

interface DashboardState {
  promosTab?: RaffleTab;
}

interface RafflePageState {
  // Код из поиска — чтобы не вводить его заново при вступлении.
  inviteCode?: string | null;
  // Пришли из списка: «Назад» равен браузерному back.
  fromList?: boolean;
}

// Вкладку пишем в запись дашборда: и браузерный back вернётся в список.
export const useOpenRafflePage = () => {
  const history = useHistory();
  const location = useLocation();

  return (raffleId: number, inviteCode: string | null, tab: RaffleTab) => {
    const dashboardState: DashboardState = { promosTab: tab };
    history.replace({ ...location, state: dashboardState });
    const pageState: RafflePageState = { inviteCode, fromList: true };
    history.push(getRafflePath(raffleId), pageState);
  };
};

export const useRafflePageNavigation = () => {
  const history = useHistory();
  const { state } = useLocation<RafflePageState | undefined>();

  return {
    inviteCode: state?.inviteCode ?? null,
    // По прямой ссылке истории нет — идём на дашборд.
    goBack: () =>
      state?.fromList ? history.goBack() : history.push("/dashboard"),
  };
};

// Вкладка для повторного открытия списка; после чтения стираем из записи,
// иначе список открывался бы и при обновлении страницы.
export const useRestoredRafflesTab = (enabled: boolean): RaffleTab | null => {
  const history = useHistory();
  const location = useLocation<DashboardState | undefined>();
  const stateTab = enabled ? location.state?.promosTab : undefined;
  const [restored] = useState<RaffleTab | null>(stateTab ?? null);

  useEffect(() => {
    if (restored) history.replace({ ...location, state: undefined });
    // Только при монтировании: дальше состояние записи нас не интересует.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return restored;
};
